import { useKorintModuleConfig } from 'korint-sdk/react';

export type DocumentCategoryType =
  | 'policyholderDocuments'
  | 'nonDelegatedDocuments'
  | 'brokerageFirmDocuments';

/**
 * Hook to get the upload mode for a specific document category from tenant-level configuration
 * @param categoryType - The type of document category
 * @returns The upload mode ('category' or 'batch') for the specified category
 */
export function useDocumentUploadMode(categoryType: DocumentCategoryType): 'category' | 'batch' {
  const documentsConfig = useKorintModuleConfig('documents');
  if (!documentsConfig?.uploadModes?.[categoryType]) {
    throw new Error(`Upload mode not found for category type: ${categoryType}`);
  }

  return documentsConfig.uploadModes[categoryType];
}
